import Image from 'app/Components/Shared/Image/image';
import React, { useState } from "react";
import { connect } from "react-redux";
import { Container } from "reactstrap";
import { isBrowser, isMobile } from "react-device-detect";
import BtnSubmit from "../../Shared/Buttons/BtnSubmit";
import images from "./images/images";
import "./AbroadMarketPriceMain";
import Config from "app/Config";

function AbroadMarketPriceMain(props) {
  const { privateSettings, businessSettings, goToPage } = props.iContent;
  const marketHeader = `פירוט המחירים ללא חבילת ${window.Config.brand_Name_HE} חו"ל`;
  const surf = "surf";
  const sms = "sms";
  const call = "call";
  const [selectedOption, setSelectedOption] = useState("ABROAD");

  const setSelectedAbroad = (event) => {
    event.preventDefault();
    setSelectedOption("ABROAD");
  };

  const setSelectedShipsAndPlanes = (event) => {
    event.preventDefault();
    setSelectedOption("SHIPS_AND_PLANES");
  };

  async function redirectTo() {
    let url = props?.data?.epiStyleInitializationData?.currentLobbyPath
      ? props?.data?.epiStyleInitializationData?.currentLobbyPath
      : goToPage.value?.url;
    const content = await props.context.loadContentByPath(url);
    props.context.navigateTo(content);
  }

  function renderFields(option) {
    const settings = option === "ABROAD" ? privateSettings : businessSettings;
    return (
      <div className="market-fields">
        <div className="double-field-container">
          {isBrowser ? (
            <>
              <div className="market-field" style={{ borderRight: "unset" }}>
                <div className="field-txt">חיוג ישיר לישראל</div>
                <div className="field-price">
                  {settings.directCallToIsraelText?.value ||
                    convertZeroToText(
                      settings.directCallToIsraelPrice.value,
                      call,
                    )}
                </div>
              </div>
              <div className="market-field" style={{ borderRight: "unset" }}>
                <div className="field-txt">גלישה ל 1MB</div>
                <div className="field-price">
                  {settings.oneMegaByteSurfText?.value ||
                    convertZeroToText(settings.oneMegaByteSurf.value, surf)}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="market-field">
                <div className="field-txt">חיוג ישיר לישראל</div>
                <div className="field-price">
                  {settings.directCallToIsraelText?.value ||
                    convertZeroToText(
                      settings.directCallToIsraelPrice.value,
                      call,
                    )}
                </div>
              </div>
              <div className="market-field">
                <div className="field-txt">גלישה ל 1MB</div>
                <div className="field-price">
                  {settings.oneMegaByteSurfText?.value ||
                    convertZeroToText(settings.oneMegaByteSurf.value, surf)}
                </div>
              </div>
            </>
          )}
        </div>
        <div className="double-field-container">
          <div className="market-field">
            <div className="field-txt">שיחה נכנסת</div>
            <div className="field-price">
              {settings.incomingCallText?.value ||
                convertZeroToText(settings.incomingCall.value, call)}
            </div>
          </div>
          <div className="market-field">
            <div className="field-txt">שליחת SMS</div>
            <div className="field-price">
              {settings.sendSMSText?.value ||
                convertZeroToText(settings.sendSMS.value, call)}
            </div>
          </div>
        </div>
        <div className="double-field-container">
          <div className="market-field">
            <div className="field-txt">שיחה מקומית</div>
            <div className="field-price">
              {settings.localCallText?.value ||
                convertZeroToText(settings.localCall.value, sms)}
            </div>
          </div>
          <div className="market-field">
            <div className="field-txt">שליחת MMS</div>
            <div className="field-price">
              {settings.sendMMSText?.value ||
                convertZeroToText(settings.sendMMS.value, sms)}
            </div>
          </div>
        </div>
        <div className="double-field-container">
          <div className="market-field">
            <div className="field-txt">שיחה בינלאומית</div>
            <div className="field-price">
              {settings.internatioanlCallText?.value ||
                convertZeroToText(
                  privateSettings.internatioanlCall.value,
                  call,
                )}
            </div>
          </div>
          <div className="market-field">
            <div className="field-txt">קבלת MMS/SMS</div>
            <div className="field-price">
              {settings.receiveMMSText?.value ||
                convertZeroToText(privateSettings.receiveMMS.value, sms)}
            </div>
          </div>
        </div>
      </div>
    );
  }

  function convertZeroToText(value, type) {
    if (value === "0") {
      if (type === call) {
        return "חינם";
      } else if (type === sms) {
        return "חינם";
      } else if (type === surf) {
        return "לא נמדד";
      }
    }
    return value;
  }

  const extraHeader = (option) => {
    if (option == "ABROAD") {
      return (
        isMobile && <div className="mobileExtraHeader">תעריפון מדינות</div>
      );
    }
    return (
      isMobile && (
        <div className="mobileExtraHeader">תעריפון מטוסים ואוניות</div>
      )
    );
  };
  return (
    <Container
      style={
        isBrowser
          ? { backgroundImage: `url(${images.background})` }
          : { backgroundImage: `url(${images.mobileBackground})` }
      }
      className={
        isBrowser
          ? "abroadMarketPriceMain-root-web"
          : "abroadMarketPriceMain-root"
      }
    >
      <div className="top-container">
        <h2 className="header-container-box">
          <div className="header">
            תעריפים ללא
            <br />
            <span className="strong">{window.Config.brand_Name_HE} חו"ל</span>
          </div>
          <div className="sub-header">
            כדי להימנע מחיובים מיותרים, שווה לטוס עם חבילת חו"ל שמתאימה לנסיעה
            שלכם
          </div>
        </h2>
        <div className="btn-container">
          <div className="custom-dual-arrow"></div>
          <div className="custom-dual-arrow"></div>
          <BtnSubmit
            text={'אני רוצה חבילה לחו"ל'}
            onclick={() => redirectTo()}
          />
        </div>
      </div>
      <div className="unify">
        <div className="market-place-tab-container">
          <div
            className={
              selectedOption === "ABROAD"
                ? "market-place-tab selected"
                : "market-place-tab"
            }
            onClick={setSelectedAbroad}
          >
            
            {privateSettings?.icon?.value?.url && (
              <div className="img-container">
                <Image className="icon-img"
                  alt="icon"
                  src={Config.epiBaseUrl + privateSettings?.icon?.value?.url} />
              </div>
            )}
            <div className="description-txt">
              {privateSettings?.tabTitle?.value}
            </div>
          </div>
          <div
            className={
              selectedOption === "SHIPS_AND_PLANES"
                ? "market-place-tab selected"
                : "market-place-tab"
            }
            onClick={setSelectedShipsAndPlanes}
          >
            {businessSettings?.icon?.value?.url && (
              <div className="img-container">
                <Image className="icon-img"
                  alt="icon"
                  src={Config.epiBaseUrl + businessSettings?.icon?.value?.url} />
              </div>
            )}
            <div className="description-txt">
              {businessSettings?.tabTitle?.value}
            </div>
          </div>
        </div>
        <div className="market-fields-container">
          {extraHeader(selectedOption)}
          <div className="market-fields-header">{marketHeader}</div>
          {renderFields(selectedOption)}
        </div>
      </div>
    </Container>
  );
}

export default connect((state) => ({ data: state.data }))(
  AbroadMarketPriceMain,
);
